<template lang="pug">
  img(
    id="image" 
    :src="img"
    style="width: 100%;"
  )
</template>

<script>
import Cropper from 'cropperjs';

const link = document.createElement('link');
link.rel = 'stylesheet';
link.href = 'https://cdnjs.cloudflare.com/ajax/libs/cropperjs/1.5.1/cropper.min.css';
document.getElementsByTagName('head')[0].appendChild(link);

export default {
  props: {
    height: {
      type: Number,
      default: 450

    },
    viewMode: {
      type: Number,
      default: 1

    },
    aspectRatio: {
      type: Number,
      default: null

    },
    minContainerWidth: {
      type: Number,
      default: 500

    },
    minContainerHeight: {
      type: Number,
      default: 500

    }
  },
  data () {
    return {
      cropper: null,
      result: null,
      img: ''
    };
  },
  methods: {
    bind (img) {
      this._initCropper(img);
    },
    crop () {
      this.$emit('crop', this.cropper.getCroppedCanvas().toDataURL('image/jpeg'));
      this.cropper.destroy();
    },
    rotate (degree) {
      this.cropper.rotate(degree);
    },
    reset () {
      this.cropper.reset();
    },
    clear () {
      this.cropper.clear();
    },
    destroy () {
      this.cropper.destroy();
    },
    _initCropper (img) {
      const image = document.getElementById('image');
      image.src = img;
      const {
        viewMode,
        aspectRatio,
        height,
        minContainerWidth,
        minContainerHeight

      } = this;
      this.cropper = new Cropper(image, {
        viewMode,
        aspectRatio,
        height,
        minContainerWidth,
        minContainerHeight

      });
    }

  }
};
</script>
